<template>
  <div class="main-content-box">
    <configZone1El/>
  </div>
</template>

<script>
import configZone1El from "@/views/page/racespecial/config_zone_1";

export default {
  name: "page_race_special",
  components:{
    configZone1El,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content-box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .banner-box{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
</style>
